import ReactCodeInput from "react-verification-code-input";
import "./styles/PromineoVerificationCodeInput.css";

// ReactCodeInput do not export it's props interface. That's why we need to create
// our own prop interface based on ReactCodeInput prop interface.
interface ReactCodeInputProps {
  type?: "text" | "number";
  onChange?: (val: string) => void;
  onComplete?: (val: string) => void;
  fields?: number;
  loading?: boolean;
  title?: string;
  fieldWidth?: number;
  fieldHeight?: number;
  autoFocus?: boolean;
  className?: string;
  values?: string[];
  disabled?: boolean;
  required?: boolean;
  placeholder?: string[];
}

export default function PromineoVerificationCodeInput(
  props: ReactCodeInputProps
) {
  return (
    <>
      <ReactCodeInput
        placeholder={Array(5).fill("X")}
        {...props}
        autoFocus={true}
        className={`promineo-verification-code-input ${props.className ?? ""}`}
      />
    </>
  );
}
